export default function () {
    const startButton = document.querySelector('.flight-calculator__start button');
    const bodyElement = document.querySelector('.flight-calculator__body');

    if (startButton) {
        startButton.addEventListener('click', () => {
            if (bodyElement.classList.contains('hidden')) {
                bodyElement.classList.remove('hidden');
            } else {
                bodyElement.classList.add('hidden');
            }
        });
    }
}
